import { render, staticRenderFns } from "./r-text.vue?vue&type=template&id=7a720176&"
import script from "./r-text.vue?vue&type=script&lang=js&"
export * from "./r-text.vue?vue&type=script&lang=js&"
import style0 from "./r-text.vue?vue&type=style&index=0&id=7a720176&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports